import React, { useState } from "react";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import Thumbnail1 from "../../assets/images/Products/productD-1.jpg";
import Thumbnail2 from "../../assets/images/Products/productD-2.jpg";
import Thumbnail3 from "../../assets/images/Products/productD-3.jpg";
import Thumbnail4 from "../../assets/images/Products/productD-4.jpg";
import Thumbnail5 from "../../assets/images/Products/productD-5.jpg";
import { FaStar } from "react-icons/fa";
import { FaPencilAlt } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import { RiShoppingCartLine } from "react-icons/ri";
import { LuBadgeCheck } from "react-icons/lu";
import { FiHeart, FiShoppingCart, FiEye, FiTrash2 } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { toast } from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdFavoriteBorder, MdFavorite, MdOutlineShare } from "react-icons/md";
import { PiClockCountdown, PiArrowClockwiseFill } from "react-icons/pi";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/zoom";
import "react-photo-view/dist/react-photo-view.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import { PhotoProvider, PhotoView } from "react-photo-view";
import Manufatur1 from "../../assets/images/Products/manifature-1.jpg";
import Manufatur2 from "../../assets/images/Products/manifature-2.jpg";
import Manufatur3 from "../../assets/images/Products/manifature-3.jpg";
import Manufatur4 from "../../assets/images/Products/manifature-4.jpg";
import Manufatur5 from "../../assets/images/Products/manifature-5.jpg";
import Customer1 from '../../assets/images/Review/customer-1.jpg';
import Product1 from "../../assets/images/Products/product-1.jpg";
import Product2 from "../../assets/images/Products/product-1.1.jpg";
import Product3 from "../../assets/images/Products/product-2.jpg";
import Product4 from "../../assets/images/Products/product-2.2.jpg";
import Product5 from "../../assets/images/Products/product-3.jpg";
import Product6 from "../../assets/images/Products/product-3.3.jpg";
import Product7 from "../../assets/images/Products/product-4.jpg";
import Product8 from "../../assets/images/Products/product-4.4.jpg";
import apiClient from "../../services/apiClient";
import { IMAGE_PATH } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addToCart as addToCartAction, removeFromCart } from "../../features/cart/cartSlice";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const ComboProduct = () => {
  const { id } = useParams();
  const [quantity, setQuantity] = useState(1);
  const [isFavorite, setIsFavorite] = useState(false);
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [mainSwiper, setMainSwiper] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const [imageHovered, setImageHovered] = useState(null);
  const [showReviewForm, setShowReviewForm] = useState(false);
  const [reviewTitle, setReviewTitle] = useState("");
  const [reviewDescription, setReviewDescription] = useState("");
  const [reviewRating, setReviewRating] = useState(0);
  const [reviewerName, setReviewerName] = useState("");
  const [reviewerEmail, setReviewerEmail] = useState("");
  const [reviewImages, setReviewImages] = useState([]);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);
  const cart = useSelector((state) => state.cart.items);
  const queryClient = useQueryClient();

  // React Query for combo product details
  const { data: comboData, isLoading: comboLoading, error: comboError } = useQuery({
    queryKey: ['combo', id, user?.id],
    queryFn: async () => {
      const response = await apiClient.get(`/combo-products/${id}`, {
        params: { 
          user_id: user ? user.id : null,
        }
      });
      return response.data;
    },
    enabled: !!id,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  // React Query for recommended products
  const { data: recommendedProducts = [], isLoading: recommendedLoading } = useQuery({
    queryKey: ['recommended-products-combo', user?.id],
    queryFn: async () => {
      const response = await apiClient.get('/products-list', {
        params: { 
          user_id: user ? user.id : null,
        }
      });
      return response.data.data.filter(p => p.is_combo !== true).slice(0, 4);
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });

  // React Query for combo sizes and variants
  const { data: sizesData } = useQuery({
    queryKey: ['combo-sizes', id, selectedSize],
    queryFn: async () => {
      const response = await apiClient.get(`/combo-sizes/${id}`, {
        params: {
          size: selectedSize,
        }
      });
      return response.data;
    },
    enabled: !!id && !!selectedSize,
  });

  // Mutation for wishlist toggle
  const wishlistMutation = useMutation({
    mutationFn: async ({ productId, productType }) => {
      const payload = {
        product_id: productId,
        user_id: user.id,
        product_type: productType,
      };
      return await apiClient.post("/wishlist", payload);
    },
    onSuccess: (response, variables) => {
      const isFavNow = response.data.fav_status === 1;
      setIsFavorite(isFavNow);
      toast.success(isFavNow ? "Added to wishlist" : "Removed from wishlist");

      // Update recommended products cache
      queryClient.setQueryData(['recommended-products-combo', user?.id], (oldData) => {
        if (!oldData) return [];
        return oldData.map(p =>
          p.id === variables.productId ? { ...p, is_fav: isFavNow } : p
        );
      });
    },
    onError: (error) => {
      console.error("Wishlist error", error);
      toast.error("Failed to update wishlist.");
    }
  });

  // Mutation for review submission
  const reviewMutation = useMutation({
    mutationFn: async (formData) => {
      return await apiClient.post('/reviews', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    },
    onSuccess: (response) => {
      toast.success('Review submitted successfully!');
      
      // Reset form
      setReviewRating(0);
      setReviewTitle('');
      setReviewDescription('');
      setReviewImages([]);
      setReviewerName('');
      setReviewerEmail('');
      setShowReviewForm(false);
      
      // Invalidate combo query to refetch with new review
      queryClient.invalidateQueries({ queryKey: ['combo', id] });
    },
    onError: (error) => {
      console.error('Error submitting review:', error);
      toast.error('Failed to submit review. Please try again.');
    }
  });

  // Update local state when query data loads
  React.useEffect(() => {
    if (comboData) {
      setIsFavorite(comboData.is_fav);
      if (comboData.size) {
        setSelectedSize(comboData.size);
      }
      if (comboData.varient) {
        setSelectedColor(comboData.varient);
      }
    }
  }, [comboData]);

  // Set user info for reviews
  React.useEffect(() => {
    if (user) {
      setReviewerEmail(user.email);
      setReviewerName(user.name);
    }
  }, [user]);

  // Show error toast if combo fetch fails
  React.useEffect(() => {
    if (comboError) {
      console.error("Error fetching combo:", comboError);
      toast.error("Failed to load combo details");
    }
  }, [comboError]);

  // Static data for fallback
  const staticCombo = {
    id: 37,
    title: "Premium Spiritual Combo Pack",
    description: "",
    combo_price: "3500.00",
    price: "4500.00",
    products: [
      {
        id: 1,
        name: "8 mm Red Sandalwood Mala",
        description: "<p><strong>Red Sandalwood 8mm Mala</strong><br>Crafted from high-quality red sandalwood beads, this 8mm mala is a symbol of spiritual purity and tranquility.</p>",
        price: "1500.00",
        sale_price: "1300.00",
        material: "Red Sandalwood",
        size: "8 mm"
      },
      {
        id: 2,
        name: "Meditation Cushion",
        description: "<p><strong>Premium Meditation Cushion</strong><br>Ergonomic design for comfortable meditation sessions. Filled with natural buckwheat hulls.</p>",
        price: "2000.00",
        sale_price: "1800.00",
        material: "Cotton, Buckwheat",
        size: "Medium"
      },
      {
        id: 3,
        name: "Yoga Mat",
        description: "<p><strong>Eco-Friendly Yoga Mat</strong><br>Non-slip surface with excellent cushioning for all types of yoga practice.</p>",
        price: "2500.00",
        sale_price: "2200.00",
        material: "Natural Rubber",
        size: "183cm x 61cm"
      }
    ],
    media: [
      { file_path: Thumbnail1 },
      { file_path: Thumbnail2 },
      { file_path: Thumbnail3 },
      { file_path: Thumbnail4 }
    ],
    reviews: [],
    is_fav: false
  };

  const breadcrumbItems = [
    { label: "Home", url: "/" },
    { label: "products", url: "/products/product" },
    { label: comboData?.title || "Loading..." },
  ];

  const thumbnails = [Thumbnail1, Thumbnail2, Thumbnail3, Thumbnail4, Thumbnail5];
  const mainImages = [Thumbnail1, Thumbnail2, Thumbnail3, Thumbnail4, Thumbnail5];

  // Image upload handler
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    
    if (reviewImages.length + files.length > 5) {
      setErrors(prev => ({
        ...prev,
        images: 'You can upload maximum 5 images'
      }));
      return;
    }

    const validFiles = files.filter(file => {
      if (!file.type.startsWith('image/')) {
        return false;
      }
      if (file.size > 5 * 1024 * 1024) {
        setErrors(prev => ({
          ...prev,
          images: 'Each image should be less than 5MB'
        }));
        return false;
      }
      return true;
    });

    setReviewImages(prev => [...prev, ...validFiles]);
    setErrors(prev => ({ ...prev, images: '' }));
  };

  const removeImage = (index) => {
    setReviewImages(prev => prev.filter((_, i) => i !== index));
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!reviewRating) newErrors.rating = 'Please select a rating';
    if (!reviewTitle.trim()) newErrors.title = 'Review title is required';
    if (!reviewDescription.trim()) newErrors.description = 'Review description is required';
    if (!reviewerName.trim()) newErrors.name = 'Your name is required';
    if (!reviewerEmail.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(reviewerEmail)) {
      newErrors.email = 'Please enter a valid email';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmitReview = async () => {
    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('product_id', id);
      formData.append('rating', reviewRating);
      formData.append('title', reviewTitle);
      formData.append('comment', reviewDescription);
      formData.append('user_id', user.id);
      formData.append('product_type', 'combo');
      
      reviewImages.forEach((image, index) => {
        if (typeof image !== 'string') {
          formData.append(`images[${index}]`, image);
        }
      });

      reviewMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };

  const toggleWishlist = (comboId) => {
    if (user) {
      wishlistMutation.mutate({
        productId: comboId,
        productType: "combo",
      });
    } else {
      toast.info("Please login to add to wishlist");
    }
  };

  const toggleCart = (combo) => {
    const existingProduct = cart.some((p) => p.id === combo.id && p.is_combo);
    if (!existingProduct) {
      dispatch(addToCartAction({ 
        ...combo, 
        quantity: 1, 
        is_combo: true,
        name: combo.title,
        sale_price: combo.combo_price,
        price: combo.combo_price
      }));
      toast.success("Combo added to cart");
    } else {
      dispatch(removeFromCart(combo.id));
      toast.success("Combo removed from cart");
    }
  };

  const addToCart = (combo) => {
    dispatch(addToCartAction({ 
      ...combo, 
      quantity: quantity, 
      is_combo: true,
      name: combo.title,
      sale_price: combo.combo_price,
      price: combo.combo_price
    }));
    toast.success("Combo added to cart");
  };

  const buyNow = (combo) => {
    dispatch(addToCartAction({ 
      ...combo, 
      quantity: 1, 
      is_combo: true,
      name: combo.title,
      sale_price: combo.combo_price,
      price: combo.combo_price
    }));
    navigate('/cart/cart');
  };

  const handleThumbClick = (index) => {
    setActiveIndex(index);
    if (mainSwiper) {
      mainSwiper.slideTo(index);
    }
  };

  const increaseQuantity = () => {
    setQuantity((prev) => prev + 1);
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const toggleFavorite = (combo) => {
    if (user) {
      wishlistMutation.mutate({
        productId: combo.id,
        productType: "combo",
      });
    } else {
      toast.info("Please login to add to wishlist");
    }
  };

  const renderStars = (rating) => {
    return [...Array(5)].map((_, i) => (
      <FaStar key={i} color={i < rating ? "#ffc107" : "#e4e5e9"} />
    ));
  };

  // Prepare all media for display
  const allMedia = React.useMemo(() => {
    const media = [];
    const combo = comboData || staticCombo;

    // Add combo image if exists
    if (combo?.image_path) {
      media.push({
        file_path: combo.image_path,
        file_type: "image/jpeg",
        is_combo_image: true,
      });
    }

    combo?.media?.forEach((mediaItem) => {
      media.push({
        ...mediaItem,
        is_combo_image: true,
      });
    });

    // Add product images
    combo?.products?.forEach((product) => {
      product.media?.forEach((mediaItem) => {
        media.push({
          ...mediaItem,
          product_name: product.name,
          is_product_image: true,
        });
      });
    });

    return media.length > 0 ? media : thumbnails.map(path => ({ file_path: path }));
  }, [comboData]);


  const handleShare = async () => {
    if (navigator.canShare && navigator.canShare({ files: [] })) {
      try {
        const response = await fetch(IMAGE_PATH + currentCombo.image_path); // image URL of your product
        const blob = await response.blob();
        const file = new File([blob], "product.jpg", { type: blob.type });
  
        await navigator.share({
          title: currentCombo.tile,
          text: `Check out this product: ${currentCombo.name}`,
          files: [file],
          url: window.location.href, 
        });
      } catch (err) {
        console.error("Error sharing with image:", err);
        fallbackCopy();
      }
    } else if (navigator.share) {
      // fallback to normal share without image
      try {
        await navigator.share({
          title: currentCombo.title,
          text: `Check out this product: ${currentCombo.title}`,
          url: window.location.href,
        });
      } catch (err) {
        console.error("Error sharing:", err);
      }
    } else {
      fallbackCopy();
    }
  };
  
  const fallbackCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      toast.success("Link copied to clipboard!");
    } catch (err) {
      toast.error("Failed to copy link");
    }
  };

  const renderSkeletonImages = () => {
    return (
      <div className="ProductDetailsLeft">
        <div className="ProductDetailsThumbBox">
          <Swiper
            direction="vertical"
            spaceBetween={10}
            slidesPerView={4}
            className="thumb-swiper"
          >
            {[...Array(4)].map((_, index) => (
              <SwiperSlide key={index}>
                <div className="ThumbnailImgBox">
                  <Skeleton height={80} width={80} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div className="ProductDetailsImgBox">
          <Skeleton height={500} />
        </div>
      </div>
    );
  };

  const renderSkeletonDetails = () => {
    return (
      <div className="ProductDetailsRight">
        <div className="ProductTilte">
          <Skeleton width={300} height={30} />
        </div>
        <div className="ProductReviewBox">
          <Skeleton width={150} height={20} />
        </div>
        <div className="ProductPriceBox">
          <Skeleton width={100} height={30} />
        </div>
        <div className="ProductStockBox">
          <Skeleton width={150} height={20} />
        </div>
        <div className="ProductQtyCartFavSare">
          <Skeleton width={120} height={50} />
          <Skeleton width={150} height={50} style={{ marginLeft: 20 }} />
        </div>
        <div className="ProductBuyNow">
          <Skeleton width={200} height={50} />
        </div>
        <div className="ProductDelveryReturnBox">
          <Skeleton width={300} height={20} />
          <Skeleton width={300} height={20} style={{ marginTop: 10 }} />
        </div>
      </div>
    );
  };

  const renderSkeletonRecommended = () => {
    return (
      <div className="homProductCardList">
        {[...Array(4)].map((_, index) => (
          <div className="ProductBox" key={index}>
            <div className="ProductImage">
              <Skeleton height={250} />
            </div>
            <div className="ProductText">
              <Skeleton width={150} height={20} />
              <Skeleton width={100} height={20} style={{ marginTop: 10 }} />
            </div>
          </div>
        ))}
      </div>
    );
  };

  // Calculate total individual price for discount calculation
  const calculateIndividualTotal = () => {
    const combo = comboData || staticCombo;
    if (!combo || !combo.products) return 0;
    return combo.products.reduce((total, product) => {
      return total + parseFloat(product.price || product.sale_price || 0);
    }, 0);
  };

  const individualTotal = calculateIndividualTotal();
  const comboPrice = comboData ? parseFloat(comboData.combo_price) : parseFloat(staticCombo.combo_price);
  const discountPercentage = individualTotal > 0 
    ? Math.round(((individualTotal - comboPrice) / individualTotal) * 100) 
    : 0;

  const selectSize = (sizeId, size) => {
    setSelectedSize(size);
    navigate(`/combo/${sizeId}`);
  };

  const handleColorSelect = (colorName, variantId) => {
    setSelectedColor(colorName);
    if (variantId) {
      navigate(`/combo/${variantId}`);
    }
  };

  // Use the actual combo data or fallback to static data
  const currentCombo = comboData || staticCombo;
  const isLoading = comboLoading && !comboData;
  const productSizes = sizesData?.sizes || [];
  const colorVariants = sizesData?.varients || [];

  return (
    <div id="ProductDetails">
      <div className="BreadCrumbsBox">
        <div className="container">
          <Breadcrumbs items={breadcrumbItems} />
        </div>
      </div>
      <div className="container">
        <div className="ProductDetailsMain">
          <div className="ProductDetailsImgBuyBox">
            {isLoading ? (
              <>
                {renderSkeletonImages()}
                {renderSkeletonDetails()}
              </>
            ) : (
              <>
                <div className="ProductDetailsLeft">
                  <div className="ProductDetailsThumbBox">
                    <Swiper
                      onSwiper={setThumbsSwiper}
                      direction="vertical"
                      spaceBetween={10}
                      slidesPerView={4}
                      watchSlidesProgress
                      className="thumb-swiper"
                    >
                      {allMedia.map((item, index) => (
                        <SwiperSlide key={index}>
                          <div
                            className={`ThumbnailImgBox ${
                              activeIndex === index ? "active" : ""
                            }`}
                            onClick={() => handleThumbClick(index)}
                          >
                            <img 
                              src={`${IMAGE_PATH}${item.file_path}`} 
                              alt={`Thumbnail ${index + 1}`} 
                            />
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  <div className="ProductDetailsImgBox">
                    <PhotoProvider>
                      <Swiper
                        modules={[Navigation, Thumbs]}
                        thumbs={{ swiper: thumbsSwiper }}
                        onSwiper={setMainSwiper}
                        onSlideChange={(swiper) =>
                          setActiveIndex(swiper.activeIndex)
                        }
                        className="main-swiper"
                      >
                        {allMedia.map((item, index) => (
                          <SwiperSlide key={index}>
                            <PhotoView src={`${IMAGE_PATH}${item.file_path}`}>
                              <img
                                src={`${IMAGE_PATH}${item.file_path}`}
                                alt={`Combo ${index + 1}`}
                                className="main-image"
                              />
                            </PhotoView>
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </PhotoProvider>
                  </div>
                </div>
                <div className="ProductDetailsRight">
                  <div className="ProductTilte">
                    <h2>{currentCombo?.title || "Premium Combo Pack"}</h2>
                  </div>
                  {currentCombo?.reviews?.length ? (
                    <div className="ProductReviewBox">
                      <div className="ReviewBox">
                        <div className="Rating">
                          <p>
                            {(
                              currentCombo.reviews.reduce((sum, review) => sum + parseInt(review.rating), 0) / 
                              currentCombo.reviews.length
                            ).toFixed(1)}
                          </p>
                        </div>
                        {renderStars(
                          Math.round(
                            currentCombo.reviews.reduce((sum, review) => sum + parseInt(review.rating), 0) / 
                            currentCombo.reviews.length
                          )
                        )}
                      </div>
                      <div className="ReviewCount">
                        <p>({currentCombo.reviews.length} review{currentCombo.reviews.length !== 1 ? 's' : ''})</p>
                      </div>
                    </div>
                  ) : (
                    <div className="ProductReviewBox">
                      <div className="ReviewCount">
                        {/* <p>No reviews yet</p> */}
                      </div>
                    </div>
                  )}

                  <div className="ProductPriceBox">
                    <div className="ProductCurrentPrice">
                      <p>₹{currentCombo?.combo_price || "3500"}</p>
                    </div>
                    {individualTotal > comboPrice && (
                      <>
                        <div className="ProductOrginalPrice">
                          <p>₹{individualTotal.toFixed(2)}</p>
                        </div>
                        <div className="PriceSaveUpto">
                          <p>-{discountPercentage}%</p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="ProductSizeBox">
                    <div className="SizeTitle">
                      <p>Size :</p>
                      <p>{selectedSize || currentCombo?.size || "One Size"}</p>
                    </div>
                    {productSizes.length > 0 && (
                      <div className="SizeBox">
                        {productSizes.map((size) => (
                          size.size && (
                            <div
                              key={size.id}
                              className={`Size ${selectedSize === size.size ? "selected" : ""}`}
                              onClick={() => selectSize(size.id, size.size)}
                            >
                              <p className="SizeShow">{size.size}</p>
                            </div>
                          )
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="ProductColorBox">
                    {colorVariants.length > 0 && (
                      <div className="SelectColorBox">
                        {selectedColor && (
                          <div className="selectcolorTitle">
                            <p>Selected Model : </p>
                            <p>{selectedColor}</p>
                          </div>
                        )}
                        
                        <div className="SelectColorImgBox">
                          {colorVariants.map((color) =>
                            color.varient_image_path && (
                              <div
                                key={color.id}
                                className={`SelectColorImg ${selectedColor === color.varient ? "active" : ""}`}
                                onClick={() => handleColorSelect(color.varient, color.id)}
                              >
                                <img src={IMAGE_PATH + color.varient_image_path} alt={color.varient} />
                              </div>
                            )
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="ProductStockBox">
                    <div className="ProductStock">
                      <p>Stock:</p>
                    </div>
                    <div className="ProductStcokShow">
                      {currentCombo?.products?.every(p => p.stock > 0) ? (
                        <p className="InStock">In Stock</p>
                      ) : (
                        <p className="OutOfStock">Out of Stock</p>
                      )}
                    </div>
                  </div>

                  <div className="ProductQtyCartFavSare">
                    <div className="ProductQtyBox">
                      <div className="QtyMinus" onClick={decreaseQuantity}>
                        <p>-</p>
                      </div>
                      <div className="QtyCount">
                        <p>{quantity}</p>
                      </div>
                      <div className="QtyPlus" onClick={increaseQuantity}>
                        <p>+</p>
                      </div>
                    </div>

                    <div className="ProductCart" onClick={() => { addToCart(currentCombo) }}>
                      <p>ADD TO CART</p>
                      <RiShoppingCartLine className="cart-icon" />
                    </div>

                    <div className="FavSareBox">
                      <div className="FavIconBoxContainer">
                        <div className="FavIconBox" onClick={() => { toggleFavorite(currentCombo) }}>
                          {isFavorite ? (
                            <MdFavorite
                              className="fav-icon"
                              style={{ color: "red" }}
                            />
                          ) : (
                            <MdFavoriteBorder className="fav-icon" />
                          )}
                          <span className="tooltip">
                            {isFavorite
                              ? "Remove from favorites"
                              : "Add to favorites"}
                          </span>
                        </div>
                      </div>

                      <div className="ShareIconBoxContainer">
                        <div className="ShareIconBox">
                          <MdOutlineShare className="share-icon" onClick={handleShare}/>
                          <span className="tooltip">Share this combo</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ProductBuyNow" onClick={() => buyNow(currentCombo)}>
                    <p>BUY IT NOW</p>
                  </div>

                  <div className="ProductDelveryReturnBox">
                    <div className="EstimateDelivery">
                      <PiClockCountdown className="delivery-icon" />
                      <p className="DeliveryTime">
                        Estimate delivery times:{" "}
                        <span className="Days">6-7 days</span> 
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          
          <div className="SpecificationsBox">
            <div className="SpecificationsHead">
              <h2>Specifications</h2>
            </div>
            <div className="ProductDetailsBox">
              <div className="ProductSortDesc" dangerouslySetInnerHTML={{ __html: currentCombo?.description || staticCombo.description }} />
              
              {/* Show descriptions of all products in the combo */}
              <div className="ComboProductDescriptions">
                {currentCombo?.products?.map((product, index) => (
                  <div className="ProductDescriptionBox" key={index}>
                    <h3>{product.name}</h3>
                    <div 
                      className="ProductDescription" 
                      dangerouslySetInnerHTML={{ __html: product.description }} 
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>


          <div className="ProductReviewSowBox">
            
            <div className="ProductReviewSowBoxHead">
              <h2>Ratings & Reviews</h2>
            </div>
            
            {/* Calculate average rating from reviews */}
            {currentCombo?.reviews?.length > 0 && (
              <div className="ReviewRateShowBox">
                <div className="ReviewRateSow">
                  <div className="TotalRate">
                    <p>
                      {(
                        currentCombo.reviews.reduce((acc, review) => acc + parseInt(review.rating), 0) / 
                        currentCombo.reviews.length
                      ).toFixed(1)}
                    </p>
                    <p>/5</p>
                  </div>
                  <div className="RateStar">
                    {renderStars(
                      Math.round(
                        currentCombo.reviews.reduce((acc, review) => acc + parseInt(review.rating), 0) / 
                        currentCombo.reviews.length
                      )
                    )}
                  </div>
                  <div className="RateCount">
                    <p>Based on {currentCombo.reviews.length} review{currentCombo.reviews.length !== 1 ? 's' : ''}</p>
                  </div>
                </div>
                
                {/* Rating distribution bar */}
                <div className="ReviewRateBarBox">
                  {[5, 4, 3, 2, 1].map((rating) => {
                    const count = currentCombo.reviews.filter(r => parseInt(r.rating) === rating).length;
                    const percentage = (count / currentCombo.reviews.length) * 100;
                    
                    return (
                      <div className="ReviewRateBar" key={rating}>
                        <div className="RateBarNumber">
                          <p>{rating}</p>
                        </div>
                        <div className="RateBarStar">
                          <FaStar />
                        </div>
                        <div className="RateBar">
                          <div 
                            className="RateBarFill" 
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                        <div className="RateUserCount">
                          <p>{count}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                <div className="ReviewRateWrite">
                  <div 
                    className="WriteReviewBox" 
                    onClick={() => setShowReviewForm(!showReviewForm)}
                  >
                    <p>Write a review</p>
                    <FaPencilAlt className="PencilIcon" />
                  </div>
                </div>
              </div>
            )}
            
            {/* Display review images gallery */}
            {currentCombo?.review_images?.length > 0 && (
              <div className="ReviewGalleryBox">
                <div className="GalleryBox">
                  {currentCombo.review_images.slice(0, 9).map((image, index) => (
                    <div className="Box" key={index}>
                      <img 
                        src={`${IMAGE_PATH}${image.image_path}`} 
                        alt={`Review ${index + 1}`} 
                      />
                    </div>
                  ))}
                  {currentCombo.review_images.length > 9 && (
                    <a href="/gallery/gallery" className="Box LastBox">
                      <img 
                        src={`${IMAGE_PATH}${currentCombo.review_images[0].image_path}`} 
                        alt="More reviews" 
                      />
                      <div className="CountTotalImg">
                        <FiPlus className="PlusIcon" />
                        <p>{currentCombo.review_images.length - 9}</p>
                      </div>
                    </a>
                  )}
                </div>
              </div>
            )}
            
            
            

            <div className="ReviewCommentBox">
              {showReviewForm && (
                <div className="ReviewFormContainer">
                  <div className="ReviewFormHeader">
                    <h3>Write a Review</h3>
                    <p>Share your thoughts about this product</p>
                  </div>

                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmitReview();
                  }}>
                    <div className="ReviewRatingInput">
                      <p>Your Rating: <span className="required">*</span></p>
                      <div className="StarRating">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <FaStar 
                            key={star}
                            className="star-icon"
                            color={star <= reviewRating ? "#ffc107" : "#e4e5e9"}
                            onClick={() => setReviewRating(star)}
                            size={24}
                          />
                        ))}
                      </div>
                      {errors.rating && <p className="error-message">{errors.rating}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Review Title <span className="required">*</span></label>
                      <input
                        type="text"
                        value={reviewTitle}
                        onChange={(e) => setReviewTitle(e.target.value)}
                        placeholder="Summarize your review"
                        className={errors.title ? 'error' : ''}
                      />
                      {errors.title && <p className="error-message">{errors.title}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Review Description <span className="required">*</span></label>
                      <textarea
                        value={reviewDescription}
                        onChange={(e) => setReviewDescription(e.target.value)}
                        placeholder="Share details about your experience with this product"
                        rows={5}
                        className={errors.description ? 'error' : ''}
                      />
                      {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>

                    <div className="ReviewFormInput">
                      <label>Upload Images (Max 5)</label>
                      <div className="image-upload-container">
                        <label className="image-upload-button">
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleImageUpload}
                            style={{ display: 'none' }}
                          />
                          <FiPlus className="upload-icon" />
                          <span>Add Photos</span>
                        </label>
                        <div className="uploaded-images-preview">
                          {reviewImages.map((image, index) => (
                            <div key={index} className="image-preview-item">
                              <img 
                                src={typeof image === 'string' ? image : URL.createObjectURL(image)} 
                                alt={`Preview ${index}`} 
                              />
                              <button 
                                type="button"
                                className="remove-image-btn"
                                onClick={() => removeImage(index)}
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                      {errors.images && <p className="error-message">{errors.images}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Your Name <span className="required">*</span></label>
                      <input
                        type="text"
                        value={reviewerName}
                        onChange={(e) => setReviewerName(e.target.value)}
                        placeholder="Enter your name"
                        className={errors.name ? 'error' : ''}
                      />
                      {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Your Email <span className="required">*</span></label>
                      <input
                        type="email"
                        value={reviewerEmail}
                        onChange={(e) => setReviewerEmail(e.target.value)}
                        placeholder="Enter your email"
                        className={errors.email ? 'error' : ''}
                      />
                      {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>
                    
                    <div className="ReviewFormActions">
                      <button 
                        type="submit"
                        className="SubmitReviewBtn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit Review'}
                      </button>
                      <button 
                        type="button"
                        className="CancelReviewBtn"
                        onClick={() => setShowReviewForm(false)}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              )}
              
              <div className="CommentBox">
                {currentCombo?.reviews?.length > 0 ? (
                  currentCombo.reviews.map((review) => (
                    <div className="ReviewCmtUserBox" key={review.id}>
                      <div className="ReviewHeader">
                        <div className="UserNameImgBox">
                          <div className="ImgBox">
                            <img 
                              src={review.user?.photo ? `${IMAGE_PATH}${review.user.photo}` : Customer1} 
                              alt={review.user?.name || 'Customer'} 
                            />
                          </div>
                          <div className="NameProductSizeBox">
                            <div className="UserName">
                              <p>{review.user?.name || 'Customer'}</p>
                            </div>
                            <div className="VerifyIconText">
                              <LuBadgeCheck />
                              <p>Verified Purchase</p>
                            </div>
                          </div>
                        </div>
                        <div className="ReviewRatingShow">
                          {renderStars(parseInt(review.rating))}
                        </div>
                      </div>
                      <div className="ReviewComment">
                        <div className="CmtTitle">
                          <p>{review.title}</p>
                        </div>
                        <div className="CmtDesc">
                          <p>{review.details}</p>
                        </div>
                        <div className="ReviewWriteTimeDate">
                          <p>{new Date(review.created_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}</p>
                        </div>
                      </div>
                      
                      {/* Display review images if any */}
                      {review.image?.length > 0 && (
                        <div className="CustomerProductPhoto">
                          {review.image.map((img, imgIndex) => (
                            <div className="PhotoBox" key={imgIndex}>
                              <img 
                                src={`${IMAGE_PATH}${img.image_path}`} 
                                alt={`Review ${imgIndex + 1}`} 
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="ReviewRateShowBox">
                    <p>Be the first to review this product!</p>
                    <div className="ReviewRateWrite">
                      <div 
                        className="WriteReviewBox" 
                        onClick={() => setShowReviewForm(!showReviewForm)}
                      >
                        <p>Write a review</p>
                        <FaPencilAlt className="PencilIcon" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="MostRelatedBox">
            <div className="MostRelatedBoxHead">
              <h2>Related Products</h2>
            </div>
            {recommendedLoading ? (
              renderSkeletonRecommended()
            ) : (
              <div className="homProductCardList">
                {recommendedProducts.map((product) => (
                  <div
                    className="ProductBox"
                    key={product.id}
                    onMouseEnter={() => setHoveredProduct(product.id)}
                    onMouseLeave={() => {
                      setHoveredProduct(null);
                      setImageHovered(null);
                    }}
                  >
                    <Link to={`/products/${product.id}`} className="productLink">   
                      <div
                        className="ProductImage"
                        onMouseEnter={() => setImageHovered(product.id)}
                        onMouseLeave={() => {
                          if (hoveredProduct !== product.id) {
                            setImageHovered(null);
                          }
                        }}
                      >
                        {product.media ? (
                          <>
                            <img
                              src={`${IMAGE_PATH}${product.media[0]?.file_path}`}
                              className={
                                imageHovered === product.id ? "fade-out" : "fade-in"
                              }
                              alt={product.name}
                            />
                            {product.media[1] && (
                              <img
                                src={`${IMAGE_PATH}${product.media[1]?.file_path}`}
                                className={
                                  imageHovered === product.id ? "fade-in" : "fade-out"
                                }
                                alt={product.name}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            <img
                              src={product.image1}
                              className={
                                imageHovered === product.id ? "fade-out" : "fade-in"
                              }
                              alt={product.title}
                            />
                            <img
                              src={product.image2}
                              className={
                                imageHovered === product.id ? "fade-in" : "fade-out"
                              }
                              alt={product.title}
                            />
                          </>
                        )}
                      </div>

                      <div className="ProductText">
                        <h3>{product.name || product.title}</h3>
                        <div className="priceContainer">
                          {product.sale_price && product.sale_price !== product.price ? (
                            <>
                              <p className="originalPrice">₹{product.price}</p>
                              <span className="offerPrice">₹{product.sale_price}</span>
                            </>
                          ) : product.offerPrice ? (
                            <>
                              <p className="originalPrice">{product.originalPrice}</p>
                              <span className="offerPrice">{product.offerPrice}</span>
                            </>
                          ) : (
                            <p className="offerPrice">₹{product.price || product.offerPrice}</p>
                          )}
                        </div>
                      </div>
                    </Link>

                    <div
                      className={`productIcons ${
                        hoveredProduct === product.id ? "visible" : ""
                      }`}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        setHoveredProduct(product.id);
                      }}
                    >
                      <div
                        className="iconBox"
                        data-tooltip={
                          product.is_fav
                            ? "Remove from wishlist"
                            : "Add to wishlist"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          toggleWishlist(product.id);
                        }}
                      >
                        {product.is_fav ? (
                          <FaHeart className="icon" style={{ color: "red" }} />
                        ) : (
                          <FiHeart className="icon" />
                        )}
                      </div>

                      <div
                        className="iconBox"
                        data-tooltip={cart.some(item => item.id === product.id) 
                          ? "Remove from cart" 
                          : "Add to cart"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          toggleCart(product);
                        }}
                      >
                        {cart.some(item => item.id === product.id) ? (
                          <FiTrash2 className="icon" />
                        ) : (
                          <FiShoppingCart className="icon" />
                        )}
                      </div>

                      <div className="iconBox" data-tooltip="Quick View">
                        <FiEye className="icon" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComboProduct;